const clientToken = import.meta.env['VITE_PAYMENTS_CLIENT_TOKEN'] as string | undefined;

export function PaymentTestModeBanner() {
  if (typeof clientToken === "string" && clientToken.startsWith("pk_test_")) {
    return (
      <div className="rounded-xl bg-amber-100 px-4 py-2 text-center text-xs font-bold text-amber-900">
        Los pagos con tarjeta están en modo de prueba: no se cobra dinero real.
      </div>
    );
  }
  return null;
}
